import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export type SalePatternIssueDocumentData = Readonly<{
    id: number;
    version: string;
    documentNumber: string;
}>;

export class SalePatternIssueDocumentQuery extends Query<SalePatternIssueDocumentData> {
    public constructor(
        public readonly templateId: number,
        public readonly date: Date
    ) {
        super();
    }
}

export class SalePatternIssueDocumentQueryHandlerBase implements QueryHandler<SalePatternIssueDocumentQuery, SalePatternIssueDocumentData> {
    public constructor(private readonly http: HttpService) { }

    public async handleAsync(query: SalePatternIssueDocumentQuery): Promise<SalePatternIssueDocumentData> {
        const url = TaggedUrl.join('documentTemplates/:id/create', [Tags.Api]);
        const id = query.templateId;

        const { data } = await this.http.post<SalePatternIssueDocumentData>(fillPlaceholders(url, { id }), {
            issueDate: query.date
        });
        return data;
    }
}

export type SalePatternIssueMultiDocumentData = SalePatternIssuingRequestData[];
export type SalePatternIssuingRequestData =
    | IssuedDocumentData
    | AlreadyIssuedDocumentData
    | NotIssuedDocumentData
    | NotIssuedDocumeProductNotCompliantWithCatalogntData;
export type IssuedDocumentData = Readonly<{ status: 'Issued'; }> & SalePatternIssueDocumentData;
export type AlreadyIssuedDocumentData = Readonly<{ status: 'AlreadyIssued'; }> & SalePatternIssueDocumentData;
export type NotIssuedDocumentData = Readonly<{ status: 'NotIssued'; reason: 'ManualNumbering'; }>;
export type NotIssuedDocumeProductNotCompliantWithCatalogntData = Readonly<{ status: 'NotIssued'; reason: 'ProductNotCompliantWithCatalog'; }>;

export class SalePatternIssueMultiDocumentQuery extends Query<SalePatternIssueMultiDocumentData> {
    public constructor(
        public readonly templateIds: number[],
        public readonly date: Date
    ) {
        super();
    }
}

export class SalePatternIssueMultiDocumentQueryHandlerBase implements QueryHandler<SalePatternIssueMultiDocumentQuery, SalePatternIssueMultiDocumentData> {
    public constructor(private readonly http: HttpService) { }

    public async handleAsync(query: SalePatternIssueMultiDocumentQuery): Promise<SalePatternIssueMultiDocumentData> {
        const url = TaggedUrl.join('documentTemplates/batch/create', [Tags.Api]);
        const urlParam = this.getMultipleIdParam(query.templateIds);

        const { data } = await this.http.post<SalePatternIssueMultiDocumentData>(url + urlParam, {
            issueDate: query.date
        });
        return data;
    }

    private getMultipleIdParam(ids: number[]): string {
        const param = 'id=';
        return `?${param}${ids.join(`&${param}`)}`;
    }
}
